import { Button, Card, CardBody, CardHead, EmptyState, Pill } from "@/components/common";
import { useConsents, useRevokeConsent } from "@/hooks/useConsents";
import { formatDate } from "@/utils/fmt";
import "./ConsentsPanel.css";

const PURPOSE_LABEL: Record<string, string> = {
  terms_of_service: "Termos de uso",
  email_marketing: "Comunicações de marketing",
  analytics: "Analytics",
  tax_processing: "Processamento fiscal",
};

// Purposes the user may withdraw (ToS is contractual, not revocable here).
const REVOCABLE = new Set(["email_marketing", "analytics"]);

export function ConsentsPanel() {
  const { data: consents = [], isLoading } = useConsents();
  const revoke = useRevokeConsent();

  return (
    <Card>
      <CardHead title="Privacidade & consentimentos" subtitle="Finalidades que você autorizou (LGPD)" />
      <CardBody>
        {consents.length === 0 ? (
          <EmptyState
            icon="shield-check"
            title={isLoading ? "Carregando…" : "Sem consentimentos ativos"}
            description={isLoading ? undefined : "Seus aceites aparecerão aqui."}
          />
        ) : (
          <ul className="consent-rows">
            {consents.map((c) => (
              <li key={c.id} className="consent-row">
                <div className="consent-row-main">
                  <div className="consent-row-name">
                    {PURPOSE_LABEL[c.purpose] ?? c.purpose}
                    <Pill tone="ativa">Ativo</Pill>
                  </div>
                  <div className="consent-row-meta">
                    Aceito em {formatDate(c.accepted_at)} · v{c.policy_version}
                  </div>
                </div>
                {REVOCABLE.has(c.purpose) && (
                  <Button
                    variant="ghost"
                    iconLeft="x"
                    onClick={() => revoke.mutate(c.purpose)}
                    disabled={revoke.isPending}
                  >
                    Revogar
                  </Button>
                )}
              </li>
            ))}
          </ul>
        )}
      </CardBody>
    </Card>
  );
}
